<template>
  <div class="widget-header" data-test="widget-header">
    <span class="title"><slot /></span>
  </div>
</template>

<style lang="scss" scoped>
.widget-header {
  margin-bottom: rem-calc(16);

  .title {
    font-family: 'Inter', sans-serif;
    font-size: rem-calc(18);
    font-weight: 600;
    line-height: rem-calc(24);
  }
}
</style>
